import { type IAudit } from '@ifs-gcp/core';

import { createAuditFileBtoa } from './createAuditFile';

export const checkUnsavedChanges = (lastSavedAuditBtoa: string | null, audit: IAudit | null) => {
  if (!lastSavedAuditBtoa || !audit) return false;

  return lastSavedAuditBtoa !== createAuditFileBtoa(audit);
};
